import "./CqlMaxId.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OperationalApplications from "./sections/OperationalApplications";
import SecuritySolutions from "./sections/SecuritySolutions";
import TechnicalServices from "./sections/TechnicalServices";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function CqlMaxIdPage() {
  return <div>
      <Header />
      <Hero />
      <OperationalApplications />
      <SecuritySolutions />
      <TechnicalServices />
      <Inquiry />
      <Footer />
    </div>;
}